<template>
  <v-container v-if="routine.id" class="ma-0 pa-0">
    <v-row v-if="loading">
      <v-col cols="12">
        <div style="height: 400px" class="d-flex align-center justify-center">
          <Loader />
        </div>
      </v-col>
    </v-row>
    <v-row class="my-0" v-else>
      <v-col cols="6" clas="d-flex flex-column">
        <v-sheet outlined rounded class="px-6 py-6">
          <div class="d-flex justify-space-between align-center">
            <h4 class="font-weight-medium">
              {{ $t('routines.routine_description_title') }}
            </h4>
            <Button
              v-if="canEditRoutine"
              icon="mdi-pencil"
              size="small"
              color="blueGrey"
              @click="showEditDialog = true"
            />
          </div>
          <p
            v-if="routine.description"
            v-linkify
            class="text-body-2 grey--text text--darken-3 mx-0 pa-0 mb-5 mt-n3"
            style="white-space: pre-line; word-break: break-word;"
          >
            {{ $sanitize(routine.description, { allowedTags: ['a'] }) }}
          </p>

          <div class="d-flex flex-column align-start mb-5">
            <FieldLabel :text="$t('routines.executed_by')" />
            <ChipAvatar class="me-2 mt-2" small :account="routine.createdBy" />
          </div>

          <div
            class="d-flex flex-column align-start mb-5"
            v-if="routine.id && routine.selectedTeam"
          >
            <FieldLabel :text="$t('common.team_one')" />

            <v-chip class="me-2 mt-2" data-private outlined small>
              {{ routine.selectedTeam.name }}
            </v-chip>
          </div>

          <div
            class="d-flex flex-column align-start mb-5"
            v-if="routine.id && siteName"
          >
            <FieldLabel :text="$t('common.site_one')" />

            <v-chip class="me-2 mt-2" data-private outlined small>
              {{ siteName }}
            </v-chip>
          </div>

          <div
            class="d-flex flex-column align-start"
            v-if="routine.id && routine.tags.length"
          >
            <FieldLabel :text="$t('common.tag_other')" />
            <div>
              <v-chip
                class="me-2 mt-2"
                v-for="tag in routine.tags"
                data-private
                small
                outlined
                :key="tag.id"
              >
                {{ tag.name }}
              </v-chip>
            </div>
          </div>

          <RoutineStartModal
            isEditing
            :open="showEditDialog"
            :routine="routine"
            @cancel="showEditDialog = false"
            @saved="handeSavedRoutine"
          />
        </v-sheet>
      </v-col>

      <v-col cols="6">
        <v-sheet outlined rounded class="px-6 py-6">
          <Notes
            :routine="routine"
            :loading="loading"
            :canEditRoutine="canEditRoutine"
            @save="$emit('updateRoutine', { notes: $event })"
          />
          <h4 class="font-weight-medium mb-4 mt-3">
            {{ $t('routines.evidence') }}
          </h4>
          <v-chip
            v-if="!routine.media.length && !canEditRoutine"
            disabled
            small
            >{{ $t('common.no_media') }}</v-chip
          >
          <MediaContainer
            class="mt-3"
            onlyThumbnails
            :readOnly="!canEditRoutine"
            :images="routine.media"
            @change="$emit('updateRoutine', { media: $event })"
          />
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import ChipAvatar from '@/components/ChipAvatar.vue'
import FieldLabel from '@/components/Core/FieldLabel.vue'
import MediaContainer from '@/components/MediaContainer/MediaContainer.vue'
import Loader from '@/components/utils/LoaderSpinner.vue'
import RoutineStartModal from '@/components/RoutineStartModal.vue'

import Notes from './Notes.vue'
import Button from '@/components/UI/Button'

export default {
  name: 'AboutTab',

  props: {
    routine: {
      type: Object,
      required: true,
    },
    loading: Boolean,
    canEditRoutine: Boolean,
  },

  components: {
    Loader,
    ChipAvatar,
    FieldLabel,
    RoutineStartModal,
    Notes,
    MediaContainer,
    Button,
  },

  data() {
    return {
      showEditDialog: false,
      isEditingEvidence: false,
    }
  },

  computed: {
    ...mapGetters(['organizationSites']),
    siteName() {
      const currentSite = this.organizationSites.find(
        site => site.id === this.routine.site
      )
      return currentSite?.name
    },
  },

  methods: {
    handeSavedRoutine() {
      this.showEditDialog = false
      this.$emit('saved')
    },
  },
}
</script>
